import { render } from "./ButtonIcon.vue?vue&type=template&id=efd2f162&scoped=true&ts=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=ts"
export * from "./ButtonIcon.vue?vue&type=script&lang=ts"

import "./ButtonIcon.vue?vue&type=style&index=0&id=efd2f162&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd2f162"]])

export default __exports__